var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPgSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 16,
    height: 16,
    rx: 2,
    fill: "#A2A5B9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.632 7C7.632 7.35733 7.54933 7.68267 7.384 7.976C7.21867 8.264 6.97333 8.49333 6.648 8.664C6.328 8.83467 5.93867 8.92 5.48 8.92H4.776V10.72H3V5.056H5.48C6.17333 5.056 6.704 5.232 7.072 5.584C7.44533 5.936 7.632 6.408 7.632 7ZM5.28 7.52C5.648 7.52 5.832 7.34667 5.832 7C5.832 6.65333 5.648 6.48 5.28 6.48H4.776V7.52H5.28Z",
    fill: "#A2A5B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6673 6.992C11.598 6.88 11.4993 6.79467 11.3713 6.736C11.2433 6.672 11.0886 6.64 10.9073 6.64C10.566 6.64 10.302 6.752 10.1153 6.976C9.92865 7.19467 9.83531 7.496 9.83531 7.88C9.83531 8.32267 9.93931 8.65333 10.1473 8.872C10.3553 9.09067 10.6753 9.2 11.1073 9.2C11.518 9.2 11.8486 9.03467 12.0993 8.704H10.6833V7.448H13.5713V9.224C13.326 9.64533 12.9873 10.008 12.5553 10.312C12.1233 10.6107 11.5766 10.76 10.9153 10.76C10.3286 10.76 9.81665 10.64 9.37931 10.4C8.94731 10.1547 8.61398 9.81333 8.37931 9.376C8.14998 8.93867 8.03531 8.44 8.03531 7.88C8.03531 7.32 8.14998 6.82133 8.37931 6.384C8.61398 5.94667 8.94731 5.608 9.37931 5.368C9.81131 5.12267 10.318 5 10.8993 5C11.6406 5 12.2433 5.17867 12.7073 5.536C13.1766 5.89333 13.454 6.37867 13.5393 6.992H11.6673Z",
    fill: "#A2A5B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPgSquare);
export default __webpack_public_path__ + "static/media/pg-square.94ea41f563c61e47311a3cc5aa58a986.svg";
export { ForwardRef as ReactComponent };